import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
const $ParametersMemoKey = (tag, _1) => ({tag, _1});
const ProductParameters = value0 => $ParametersMemoKey("ProductParameters", value0);
const CategoryParameters = value0 => $ParametersMemoKey("CategoryParameters", value0);
const ModifierParameters = value0 => $ParametersMemoKey("ModifierParameters", value0);
const ParameterParameters = value0 => $ParametersMemoKey("ParameterParameters", value0);
const MenuCatalogueMemo = x => x;
const hasFieldMenuCatalogueMemo = dictHasField => ({getField: label => v => dictHasField.getField(label)(v.catalogue)});
const genericParametersMemoKey_ = {
  to: x => {
    if (x.tag === "Inl") { return $ParametersMemoKey("ProductParameters", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ParametersMemoKey("CategoryParameters", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $ParametersMemoKey("ModifierParameters", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $ParametersMemoKey("ParameterParameters", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ProductParameters") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "CategoryParameters") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ModifierParameters") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "ParameterParameters") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showParametersMemoKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ProductParameters"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "CategoryParameters"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ModifierParameters"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [v]})({reflectSymbol: () => "ParameterParameters"});
    return x => {
      const $4 = genericParametersMemoKey_.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const eqParametersMemoKey = {
  eq: x => y => {
    if (x.tag === "ProductParameters") {
      if (y.tag === "ProductParameters") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "CategoryParameters") {
      if (y.tag === "CategoryParameters") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ModifierParameters") {
      if (y.tag === "ModifierParameters") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ParameterParameters") {
      if (y.tag === "ParameterParameters") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const ordParametersMemoKey = {
  compare: x => y => {
    if (x.tag === "ProductParameters") {
      if (y.tag === "ProductParameters") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ProductParameters") { return Data$dOrdering.GT; }
    if (x.tag === "CategoryParameters") {
      if (y.tag === "CategoryParameters") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CategoryParameters") { return Data$dOrdering.GT; }
    if (x.tag === "ModifierParameters") {
      if (y.tag === "ModifierParameters") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ModifierParameters") { return Data$dOrdering.GT; }
    if (x.tag === "ParameterParameters") {
      if (y.tag === "ParameterParameters") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqParametersMemoKey
};
const toCatalogue = v => v.catalogue;
const parametersMemo = v => v.parametersMemo;
const memoLookup = dictOrd => memoRef => k => compute => {
  const memoData = memoRef.value;
  const v = Data$dMap$dInternal.lookup(dictOrd)(k)(memoData);
  if (v.tag === "Just") { return v._1; }
  if (v.tag === "Nothing") {
    const v1 = compute();
    const $0 = memoRef.value;
    memoRef.value = Data$dMap$dInternal.insert(dictOrd)(k)(v1)($0);
    return v1;
  }
  $runtime.fail();
};
const memo = catalogue => ({catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}});
export {
  $ParametersMemoKey,
  CategoryParameters,
  MenuCatalogueMemo,
  ModifierParameters,
  ParameterParameters,
  ProductParameters,
  eqParametersMemoKey,
  genericParametersMemoKey_,
  hasFieldMenuCatalogueMemo,
  memo,
  memoLookup,
  ordParametersMemoKey,
  parametersMemo,
  showParametersMemoKey,
  toCatalogue
};
